<div class="video-overlay">
    <div class="content">
        <div class="left">
            <div class="count-down">
                <p>You just watched</p>
                <p class="timer">Up next in <span class="countdown">{{countdown}}</span></p>
            </div>
            <h3>{{{video.video_title}}}</h3>
            {{#if video.button_cta_link}}
            <a class="btn btn-block learn-more-btn" href="{{{video.button_cta_link}}}" target="_blank">{{{video.button_cta}}}</a>
            {{/if}}
            <a href="#" class="btn btn-outline watch-again">
                <img src="https://d2jxp14m02ldtn.cloudfront.net/video-widget/assets/img/watch-again.svg" alt="Watch again">
                <span>Watch again</span>
            </a>
            
        </div>

        <div class="right">
            <div class="count-down">
                <p class="timer">Up next in <span class="countdown">{{countdown}}</span></p>
                <a href="#" class="btn btn-outline autoplay-cancel">Cancel</a>
            </div>

            {{#each next_videos}}
                {{#if @first}}
                <a href="#" data-playlist-id="{{playlistItemId_}}" class="next-video">
                    <img class="img-fluid" src="{{video.thumbnail_link}}" alt="">
                </a>
                {{else}}
                <a href="#" data-playlist-id="{{playlistItemId_}}" class="next-video small">
                    <img class="img-fluid" src="{{video.thumbnail_link}}" alt="">
                    <span>{{{video.video_title}}}</span>
                </a>

                {{/if}}
            {{/each}}
            
        </div>
    </div>
</div>